import DOMPurify from "dompurify";
import { cn } from "../lib/utils";

const HtmlContent = ({ html, className }) => {
  const cleanHtml = DOMPurify.sanitize(html);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
      className={cn(
        "html-content",
        // Images
        "[&_img]:max-w-full",
        "[&_img]:h-auto",
        "[&_img]:object-contain",
        "[&_img]:block",

        // Optional: prevent long content from overflowing
        "[&_table]:max-w-full",
        "[&_table]:overflow-x-auto",
        className,
      )}
    />
  );
};

export default HtmlContent;
